module.exports = __webpack_public_path__ + "static/media/back2.9f4037d9.svg";